<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-01 11:52:56
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 17:02:08
 * @Description: file content
 很多宝创建页面 模板1
 -->

<template>
  <div class="LayoutFound2" style="padding-bottom:50px;">
    <remote-script
      charset="utf-8"
      src="https://assets.rurushishi.com/h5/lib/jquery/jquery-1.10.2.min.js"
    ></remote-script>
    <remote-link src="/sharelib/css/index.css?v=2"></remote-link>
    <remote-script charset="utf-8" src="/sharelib/sharelib.js"></remote-script>
    <router-view></router-view>
    <Tabbar4></Tabbar4>
    <BtnHome></BtnHome>
  </div>
</template>

<script>
import util from "@/utils/utils";
import Cookies from "js-cookie";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
const Tabbar4 = () => import("@/components/tabbar4");
const BtnHome = () => import("@/components/btn_home");
export default {
  components: {
    Tabbar4,
    BtnHome
  },
  props: {},
  data() {
    return {
      selfAction: {
        //弹出自行动播放音乐
        promptSound: new Audio(
          "https://assets.rurushishi.com/sharelib/iPhone.mp3"
        ),
        triggerTime: 12, //等待时间秒
        passedTime: 0 //秒
      }
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isLoading",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo",
      "sourceGzhInfo"
    ])
  },
  methods: {
    ...mapMutations({
      SET_PAGEINFO: "SET_PAGEINFO",
      SET_SOURCEGZHINFO: "SET_SOURCEGZHINFO"
    }),
    // 设置内容自行动
    setSelfAction: function() {
      let that = this;
      comreq.checkPageSelf(that.pageInfo.PageId).then(function(data) {
        // 设置了自行动，开启定时器
        if (data) {
          let zxdObj = Cookies.get("t5_20190802_self_" + that.pageInfo.PageId);
          if (zxdObj) {
            that.showSelfAction(1);
          } else {
            let tmpInterval = setInterval(function() {
              that.selfAction.passedTime++;
              if (that.selfAction.triggerTime == that.selfAction.passedTime) {
                that.showSelfAction(0);
                let inFifteenMinutes = new Date(
                  new Date().getTime() + 365 * 24 * 60 * 60 * 1000
                );
                Cookies.set("t5_20190802_self_" + that.pageInfo.PageId, 1, {
                  expires: inFifteenMinutes
                });
                clearInterval(tmpInterval);
              }
            }, 1000);
          }
        }
      });
    },
    showSelfAction: function(type) {
      let option = {
        pageid: this.pageInfo.PageId,
        openid: this.$openid,
        refereeopenid: this.$refereeopenid,
        passport: this.$passport,
        chaturl: util.getGzhChatUrl(this),
        apiurl: this.global.API_URL
      };
      if (type == 1) {
        option.type = 1;
      } else {
        // 自行动首次弹出
        this.selfAction.promptSound.play();
      }
      ShareLibSDK.showPageSelfConfig(option);
    },
    // 分享后页面
    showShareAfterAction: function() {
      let that = this;
      if (that.pageInfo.Showsharepage == 1) {
        let shareLibOption = {
          pageid: parseInt(that.pageInfo.PageId),
          openid: that.$openid,
          passport: that.$passport,
          apiurl: that.global.API_URL,
          refereeopenid: that.$refereeopenid
        };
        if (window.ShareLibSDK) {
          window.ShareLibSDK.showShareWin(shareLibOption);
        } else {
          let tmpInterval = setInterval(() => {
            if (window.ShareLibSDK) {
              window.ShareLibSDK.showShareWin(shareLibOption);
            }
          }, 500);
        }
      }
    },
    // 发送浏览时长
    sendTime(guid) {
      let that = this;
      let postObj = {
        openid: this.$openid,
        pageid: this.$pageid,
        tempid: guid,
        channelid: "",
        refereeopenid: this.$refereeopenid,
        projectid: this.pageInfo.Pid,
        psn: this.$psn
      };
      comreq.actIp(this, postObj);
    },
    // 开始统计浏览时长
    setSendTime() {
      let that = this;
      let guid = util.getGuid();
      setTimeout(function() {
        that.sendTime(guid);
        setInterval(function() {
          that.sendTime(guid);
        }, 3000);
      }, 1000);
    }
  },
  beforeCreate() {},
  created() {
    const that = this;
    if (
      util.queryCheck(
        {
          id: "PageId",
          psn: "防刷参数"
        },
        that.$route.query
      )
    ) {
      // 获取页面信息
      comreq
        .getPageInfo(that.$route.query.id, that.$route.query.psn, that)
        .then(function(pageInfo) {
          that.SET_PAGEINFO(pageInfo);
          if (that.$route.query.isnew && that.$route.query.isnew == 1) {
            that.isShowCreateAfterGuide = true;
          }
          // 微信网页
          // 需要设置分享
          util.setFoundShare(pageInfo, that.shareSpreadInfo);
          that.global.SHARE_CALLBACK_OK = function() {
            comreq.actShare(that);
            // 很多宝先隐藏了分享后页面
            // that.showShareAfterAction();
          };
        });
      // 设置内容自行动
      util.checkMapStateCallback(that, ["pageInfo"]).then(() => {
        comreq
          .getChannelInfoByPageId(that.pageInfo.PageId)
          .then(function(sourceGzhInfo) {
            that.SET_SOURCEGZHINFO(sourceGzhInfo);
          });
        that.setSelfAction();
        that.setSendTime();
        // 上报设备信息
        comreq.actMt(that);
      });
    }
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.LayoutFound2 {
}
</style>